<div class="container" *ngIf="visible">
    <iframe [src]="bridge" width="100%" height="1200" type='application/pdf'></iframe>
</div>